<template>
  <div class="bcc-file-list">
      <div
        :class="wrpClasses(item)"
        v-for="(item, index) in files"
        :key="index"
      >
      <bcc-icon class="icon" type="icon_tasklist_delete_" size="18px" @click="handleDelete(index)"></bcc-icon>
        <span class="item-content">{{item.name}}</span>
      </div>
    </div>
</template>

<script>
const prefixCls = 'item'
export default {
  name: 'filelist',
  props: ['files'],
  methods: {
    wrpClasses (item) {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-success`]: item.url && item.status === 'success',
          [`${prefixCls}-pending`]: item.status === 'pending',
          [`${prefixCls}-failed`]: item.status === 'failed'

        }
      ]
    },
    handleDelete (index) {
      this.$emit('handleDelete', { index })
    }
  }
}
</script>
